import { useCheckoutSuccess } from '@/hooks/useCheckoutSuccess';

/**
 * Component that detects checkout success and clears cart
 * Must be inside ShopifyCartProvider to access cart context
 */
export const CheckoutSuccessDetector = () => {
  useCheckoutSuccess();
  return null; // This is a logic-only component
};
